import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import username from 'flarum/common/helpers/username';

/**
 * "Somebody said something about your picture."
 */
export default class CommentNotification extends Notification {
  icon() {
    return 'fas fa-comment';
  }
  href() {
    const subject = this.attrs.notification.subject();
    return subject ? app.route('atrium.image', {
      id: subject.id()
    }) : app.route('atrium.index');
  }
  content() {
    return app.translator.trans('ernestdefoe-atrium.forum.notifications.comment', {
      // 🚨 Never a placeholder named `user`. Flarum's translator singles that
      // one name out and calls displayName() on whatever it is given, so a
      // vnode throws and a deleted uploader throws — and the throw happens
      // inside an ItemList callback, which swallows everything after it.
      username: username(this.attrs.notification.fromUser())
    });
  }
  excerpt() {
    /*
     * The picture's own title, not the comment. A notification that quotes the
     * comment is a notification people read instead of opening — which is fine
     * for a forum reply and wrong for a gallery, where the thing worth looking
     * at is the picture.
     */
    const subject = this.attrs.notification.subject();
    return subject?.title() || subject?.albumTitle() || null;
  }
}
flarum.reg.add('ernestdefoe-atrium', 'forum/components/CommentNotification', CommentNotification);